import { atom } from 'recoil';
import { TLockItem } from '@/components/tour/game/NewLocks/LockInfoPopup/types';

export const lockTimerState = atom<{ value: number; running: boolean }>({
  key: 'lockTimerState',
  default: { running: false, value: 0 },
});

export const lockInfoPopupStatusState = atom<null | TLockItem>({
  key: 'lockInfoPopupStatusState',
  default: null,
});

export const gamePointsState = atom({
  key: 'gamePointsState',
  default: 0,
});
